import React from 'react';
import PropTypes from 'prop-types';

const AtomNumberDisplay = ({
  value, 
  locale = 'fr-FR', 
  currency = 'EUR', 
  withCurrency = true, 
  className = '', 
  icon = null,
  align = 'right' // Nouvelle prop pour l'alignement
}) => {
  // Fonction pour formater le nombre
  const formatNumber = (num) => {
    const parsedNum = Number(num);
    if (isNaN(parsedNum)) {
      return 'Invalid number';
    }

    const options = withCurrency
      ? { style: 'currency', currency }
      : { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 };

    return new Intl.NumberFormat(locale, options).format(parsedNum);
  };


  return (
    <>
      {icon && <span className="number-icon mr-1">{icon}</span>}
      {formatNumber(value)}
    </>
  );
};

// PropTypes pour le typage
AtomNumberDisplay.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  locale: PropTypes.string,
  currency: PropTypes.string,
  withCurrency: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  align: PropTypes.oneOf(['left', 'right', 'center'])
};

export default AtomNumberDisplay;
